import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'

import image from './learning.svg'
import { flexBreakpoint } from '../../components/Info/styles'

const styles = (theme) => {
  return createStyles({
    image: {
      [theme.breakpoints.up(flexBreakpoint)]: {
        width: '24.5rem',
      },
    },
  })
}

const Image = ({ classes }) => {
  return (
    <img
      src={image}
      alt="A woman sitting on a chair near a desk. She is holding a document and reading it. There is a laptop showing a person wearing formal attire."
      className={classes.image}
    />
  )
}

export default withStyles(styles)(Image)
